import React, { useState, createContext, useContext, useEffect } from "react";
import { useTranslations } from "@gf-easy-8/grmnext-foundation";

export type SnackBar = {
  message: string;
  title: string;
  snackbarType?: "WARNING" | "ALARM" | "SUCCESS";
  expiration: number;
};

export const SnackBarContext = createContext<any>([
  {},
  () => {
    return;
  },
]);

export const offsetAnimation = 1000;
const expiration = 5000;

export const SnackBarProvider = ({
  children,
}: JSX.ElementChildrenAttribute): JSX.Element => {
  const { getTranslation } = useTranslations();
  const [snackBars, setSnackBars] = useState<SnackBar[]>([]);

  const getExpiration = () => {
    return new Date().getTime() + expiration + offsetAnimation;
  };

  const removeSnackBar = (index: number) => {
    const newSnackBars = [...snackBars];
    newSnackBars.splice(index, 1);
    setSnackBars(newSnackBars);
  };

  const pushErrorMessage = (message: string) => {
    setSnackBars([
      {
        message: message,
        title: getTranslation("GLOBAL:ERROR"),
        snackbarType: "ALARM",
        expiration: getExpiration(),
      },
      ...snackBars,
    ]);
  };

  const pushSuccessMessage = (message: string) => {
    setSnackBars([
      {
        message: message,
        title: getTranslation("GLOBAL:SUCCESS"),
        snackbarType: "SUCCESS",
        expiration: getExpiration(),
      },
      ...snackBars,
    ]);
  };

  return (
    <SnackBarContext.Provider
      value={{
        snackBarContext: {
          snackBars: [snackBars, setSnackBars],
          modify: { pushErrorMessage, pushSuccessMessage, removeSnackBar },
        },
      }}
    >
      {children}
    </SnackBarContext.Provider>
  );
};

const useSnackBar = () => useContext(SnackBarContext);
export default useSnackBar;
